import { ICLITokenType, IMutation } from '@app/@introspection';
import { Injectable } from '@rxdi/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseGraphqlService } from '../base';

@Injectable()
export class CLIService extends BaseGraphqlService {
  generateCLIToken(): Observable<ICLITokenType> {
    return this.mutate<IMutation>({
      mutation: 'generate-cli-token.graphql',
    }).pipe(map(({ data }) => data.generateCLIToken));
  }
  revokeCLIToken(): Observable<ICLITokenType> {
    return this.mutate<IMutation>({
      mutation: 'revoke-cli-token.graphql',
    }).pipe(map(({ data }) => data.revokeCLIToken));
  }
}
